import TrackElements from '@capsule/track-elements'
import PmcBridge from 'shared/services/pmc-bridge'
import Toast from 'shared/toast/toast'

export default class ArticleBrief {
	private briefCta: HTMLElement | null
	private briefBlock: HTMLElement | null
	private pmcBridge: PmcBridge
	private trackElements: TrackElements | null

	constructor() {
		this.briefCta = document.querySelector('#article-userActionsBrief')
		this.briefBlock = document.querySelector('#articleBrief')
		this.pmcBridge = new PmcBridge()
		this.trackElements = null

		this.onBriefCtaClick = this.onBriefCtaClick.bind(this)
	}

	init() {
		if (!this.briefCta) return

		this.trackElements = new TrackElements([
			{
				element: this.briefCta,
				display: {
					event: 'button_display',
					button_name: 'cta-services-summary'
				}
			},
			{
				element: this.briefCta,
				click: {
					event: 'button_click',
					button_name: 'cta-services-summary'
				}
			}
		])
		this.trackElements.init()

		this.briefCta.addEventListener('click', this.onBriefCtaClick)
	}

	private async onBriefCtaClick() {
		if (!this.briefCta) return

		const isPaidArticle = this.briefCta.dataset.paidArticle === 'true'

		if (isPaidArticle) {
			const isSubscribed = await this.pmcBridge.hasSubscription()

			if (!isSubscribed) {
				const brandName = this.briefCta.dataset.brandName ?? ''
				const feedbackContent = document.createElement('span')
				feedbackContent.innerHTML = `Résumé accessible aux abonnés ${brandName}. Déjà abonné ? <button class="auth pmc-authentification" type="button">Connectez-vous</button>. 🙂`

				new Toast({ content: feedbackContent }).init()
				return
			}
		}

		this.briefBlock?.classList.remove('hidden')
		this.typewriteContent()
		this.briefCta.setAttribute('aria-expanded', 'true')
		this.briefCta.removeEventListener('click', this.onBriefCtaClick)
	}

	private typewriteContent(): void {
		const container = this.briefBlock?.querySelector('.articleBrief-content')
		if (!container) return

		const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT)
		const textNodes: Array<{ node: Text; content: string }> = []

		let current = walker.nextNode()
		while (current) {
			const textNode = current as Text
			const content = textNode.textContent ?? ''
			if (content.trim()) {
				textNodes.push({ node: textNode, content })
				textNode.textContent = ''
			}
			current = walker.nextNode()
		}

		let nodeIndex = 0

		const typeNextNode = () => {
			if (nodeIndex >= textNodes.length) return

			const { node, content } = textNodes[nodeIndex]
			let charIndex = 0

			const typeChar = () => {
				if (charIndex < content.length) {
					node.textContent += content[charIndex]
					charIndex++
					setTimeout(typeChar, 10)
				} else {
					nodeIndex++
					typeNextNode()
				}
			}

			typeChar()
		}

		typeNextNode()
	}
}
